import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IAIAgentTemplate, IAIAgentTemplateFormData } from '../../extViewmodels/sdk/models/AI';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useCreateAIAgentTemplateMutation({
	onError,
	onSuccess,
	onSettled,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IAIAgentTemplate) => void;
	onSettled?: () => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({
			data,
			impersonationContext,
		}: {
			data: IAIAgentTemplateFormData;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<IAIAgentTemplate>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'aiagenttemplate' }),
				'POST',
				data
			);
		},
		onError,
		onSuccess,
		onSettled,
	});
}
